import { useMemo } from 'react';

import map from 'lodash/map';

import {
  FacilityResponseType,
  useLaborLevelDesignations,
  useLabourLevelFacilitiesGet,
} from '@sbv-clients/data-access-api';

import {
  BaseFieldProps,
  createOptionsFieldBuilder,
} from '../hoc/fields-builder';

type ExtraParameters = {
  getLabel?: (item: FacilityResponseType) => string;
};

const useLaborLevelFacilityOptionsGet = ({ getLabel }: ExtraParameters) => {
  const { data = [], isLoading, isSuccess } = useLabourLevelFacilitiesGet();
  const options = useMemo(
    () =>
      map(data, (item) => ({
        id: item.facilityId as number,
        label: getLabel ? getLabel(item) : item.facilityName ?? '',
        value: item.facilityId as number,
      })),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [data]
  );

  return { options, isLoading, isSuccess };
};

const dataFetcher = useLaborLevelFacilityOptionsGet;
type Props = BaseFieldProps & ExtraParameters;

const hookParamsGetter = (props: Props): ExtraParameters => ({
  getLabel: props.getLabel,
});

export const {
  FacilitySelectField,
  FacilityFormSelectField,
  FacilityDataGridSelectField,
  FacilityIdToLabelRenderer,
} = createOptionsFieldBuilder({
  prefix: 'Facility',
  useOptionsHook: dataFetcher,
  extractHookParams: hookParamsGetter,
  useLabelHook: () => useLaborLevelDesignations()?.data?.facility?.name ?? '',
});
